<template>
  <div class="content" >
    <WebHeader menu='2' ></WebHeader>
    <div class="web-page">
      <div  class="imgdiv">
        <img src="static/img/deptIntroduction/socialHeaderImage.jpg">
        <div id="benImg2" class="auxiliary"></div>
      </div>

<!--      <el-carousel  style="width:100%">-->
<!--        <el-carousel-item v-for="item in imgArray" :key="item">-->
<!--          <img :src="item" class="rightImg">-->
<!--          <div class="el-carousel__button"></div>-->
<!--        </el-carousel-item>-->
<!--      </el-carousel>-->
      <!-- 第一部分 -->
      <div  class="navigate-fixed">
        <div style="padding: 80px 0px;"></div>
        <a @click="slide('yingxiang')"><img class="end80" :src="slideImg[0]" ></a>
        <a @click="slide('chaosheng')"><img class="end80" :src="slideImg[1]" ></a>
        <a @click="slide('shengming')"><img class="end80" :src="slideImg[2]" ></a>
        <a @click="slide('duibi')"><img class="end80" :src="slideImg[3]" ></a>
      </div>
      <div id="index1" class="titleImg">
        <img id="yingxiang" class="imgTite" src="static/img/deptIntroduction/yingxiang.png">
        <p  class="subtitle">影像</p>
        <div class="triangle"></div>
      </div>
      <div id="end1" class="deptimage1">
        <div class="dept1"></div>
        <div class="dept2"></div>
        <div class="dept4">
          <img src="static/img/deptIntroduction/yingxiang_img.png" align="right"/>
        </div>
        <p class="dept4p">
          GE医疗影像事业部秉承共创无界的医疗关爱之使命，一直以疾病和病人为核心，迎接医疗行业挑战，不断创新和超越，提供行业内先进的医疗设备和解决方案，与中华医学会放射学分会，心血管分会，中国医师协会等行业协会和国内外专业大咖开展深度合作，并践行医学影像的人才培养规划，不断履行企业社会责任。
          <br/>
          <br/>
          <!--US202501035   更改标点符号    lmg-->
          业界知名的Revolution CT，诺亚方舱CT定点解决方案，亚洲首套15T MR转化医学方案强势入驻华西医院，珠峰3.0T磁共振建筑了中国磁共振领域的新高度，专为复合手术室打造Discovery自由移动机器人，One MI 生态圈建立了分子影像行业典范，这是唯一的闭环产业链，e-digital远程应用实时解决客户问题。GE医疗中国影像事业部在各个领域一直肩负医疗重任并引领行业发展。

        </p>
        <div style="clear: both"></div>
      </div>
      <!-- 第一结束 -->
      <!-- 第二部分 -->
      <div id="index2" class="titleImg">
        <img id="chaosheng" class="imgTite" src="static/img/deptIntroduction/chaosheng.png">
        <p  class="subtitle">超声</p>
        <div class="triangle"></div>
      </div>
      <div id="end2" class="deptimage1">
<!--        <div class="us1"></div>-->
        <div class="us3"></div>
        <div class="us2"></div>
        <div class="two_img">
          <img src="static/img/deptIntroduction/chaosheng_img.png" align="left" />
        </div>
        <p class="two_imgp">
          <!--US202501035   更改标点符号    lmg-->
          GE医疗超声立足百年基业，以全球创新智慧、中国研发生产，为各级医疗机构提供覆盖全身、妇产、心脏、急重症、乳腺等专业细分的解决方案，覆盖从诊断领域到手术治疗的全过程产品线，惠及中国医患。自1996年正式推出超声产品以来，GE医疗超声先后并购行业内知名优秀的超声公司，并不断加大投入进行全新产品开发和技术突破，历经数十年突飞猛进的发展，坚持走专业化细分路线，形成了满足不同医院、不同科室、应对多种诊疗环境所需的专业化系列产品，面向中高端市场，提供全能型产品解决方案，包括超声造影、介入、儿科、肌骨、妇科、产科、乳腺、 心脏、急重症等，面向县域和基层医疗机构，定制专属超声产品，便捷易用，5G赋能县域医共体远程质控及诊疗。
        </p>
        <div style="clear: both"></div>
      </div>
      <!-- 第二结束 -->

      <!-- 第三部分 -->
      <div id="index3" class="titleImg">
        <img id="shengming" style="padding-top: 38px" src="static/img/deptIntroduction/Hearts.png">
        <p  class="subtitle">生命关爱</p>
        <div class="triangle"></div>
      </div>
      <div id="end3" class="deptimage1">
        <div class="lifeCare"></div>
<!--        <div class="lifeCare2"></div>-->
        <div class="lifeCare3"></div>
        <div class="dept4">
          <img src="static/img/deptIntroduction/shengming_img.png" align="right"/>
        </div>
        <p class="dept4p">
          GE医疗生命关爱事业部涉及预防、诊断、监护以及治疗等多个领域，产品覆盖：麻醉机、麻醉超声、围术期智慧管理系统、呼吸机、病人监护仪、心电分析仪，心电信息管理系统和暖箱辐射台等，面向医疗机构的急诊、麻醉、重症、心功能科、新生儿等多个科室，提供全面解决方案。GE医疗生命关爱事业部在麻醉、呼吸、监护、心电几个领域拥有数十年的创新历史以及引领性技术，沿袭传承Datex-Ohmeda、Marquette等行业内百年技术沉淀的同时，不断融合GE医疗强大的研发和整合能力，推出了众多跨时代产品，引领学科发展，谱写生命传奇。GE医疗生命关爱事业部始终致力于以患者为本，为患者提供全面的诊疗方案，为医生提供先进的医疗技术，为医院提供完备的医疗设备，关爱每一位患者的生命健康。
        </p>
        <div style="clear: both"></div>
      </div>
      <!-- 第三结束 -->
      <!-- 第四部分 -->
      <div id="index4" class="titleImg">
        <img id="duibi" class="imgTite" src="static/img/deptIntroduction/contrastAgent.png">
        <p  class="subtitle">诊断药物</p>
        <div class="triangle"></div>
      </div>
      <div id="end4" class="deptimage1">
        <div class="contrastAgent1"></div>
<!--        <div class="contrastAgent2"></div>-->
        <div class="contrastAgent3"></div>
        <div class="two_img">
          <img src="static/img/deptIntroduction/duibiji_img.png" align="left" />
        </div>
        <p class="two_imgp">
          GE医疗诊断药物隶属于GE医疗，是全球及中国最大的对比剂成品及原料生产厂家之一，位于上海的工厂是GE医疗全球三大对比剂生产基地之一，也是最大的生产基地，占全球60%的产量，产品出口全世界三十多个国家，是中国首家获得美国FDA、GMP批准的大容量静脉注射液生产厂家。主要产品有欧乃派克、威视派克、欧乃影和示卓安。
          <br>
          <br>
          <!--US202501035   更改标点符号    lmg-->
          欧乃派克是国内上市较早的次高渗对比剂，规格齐全，有着广泛的适应症及优越的安全性；威视派克作为原研的等渗对比剂，拥有全面的心肾安全性及注射舒适性；欧乃影拥有广泛的适应症及优越的安全性，是原研非离子磁共振钆对比剂；示卓安作为新一代肝脏特异性超声对比剂，将会助力实现肝癌精准一体化，全程为肝癌患者保驾护航。
        </p>
        <div style="clear: both"></div>
      </div>
      <div class="replenish"></div>
      <!-- 第四结束 -->
<!--      <div :class="[DW1]" class="DW">-->
<!--        <a @click="slide('yingxiang')"><img class="end80" :src="slideImg[0]" ></a>-->
<!--        <a @click="slide('chaosheng')"><img class="end80" :src="slideImg[1]" ></a>-->
<!--        <a @click="slide('shengming')"><img class="end80" :src="slideImg[2]" ></a>-->
<!--        <a @click="slide('duibi')"><img class="end80" :src="slideImg[3]" ></a>-->
<!--      </div>-->
    </div>
    <top-button></top-button>
    <WebFooter></WebFooter>
<!--    <WebLoading></WebLoading>-->
  </div>
</template>
<script>
  // window.onload = function () {
  //   document.getElementById('pageLoading').remove();
  // }
    import TopButton from "../../components/web/topButton";

  export default {
        name: "DeptIntroduction",
       components: {TopButton},
      data() {
        return {
          slideImg:[
            require('../../../static/img/deptIntroduction/影像.png'),
            require('../../../static/img/deptIntroduction/超声.png'),
            require('../../../static/img/deptIntroduction/生命关爱.png'),
            require('../../../static/img/deptIntroduction/对比剂.png')
          ],
          selectedImg:[
            require('../../../static/img/deptIntroduction/影像选中.png'),
            require('../../../static/img/deptIntroduction/超声选中.png'),
            require('../../../static/img/deptIntroduction/生命关爱选中.png'),
            require('../../../static/img/deptIntroduction/对比剂选中.png')
          ]


        }
      },
      methods: {
        slide(vales){
          // 解决页面未加载完 获取不到ID未能跳到指定位置问题
          setTimeout(()=>{
            document .getElementById(vales) .scrollIntoView({ behavior: 'smooth' })
          },100)
        },
        scrollToTop() {
          // 获取视窗高度
          //var domHight = document.body.offsetHeight;
          // dom滚动位置
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

          if(document.getElementById('benImg2')){
            // 获取监听元素本身高度
            let offsetTopbenImg = document.getElementById('benImg2').offsetTop;
            let scrollHeightbenImg = document.getElementById('benImg2').scrollHeight;
            if (scrollTop >= offsetTopbenImg && scrollTop<=(offsetTopbenImg+scrollHeightbenImg)) {
              //恢复原有状态
              this.$set(this.slideImg,0,require('../../../static/img/deptIntroduction/影像.png'))
              this.$set(this.slideImg,1,require('../../../static/img/deptIntroduction/超声.png'))
              this.$set(this.slideImg,2,require('../../../static/img/deptIntroduction/生命关爱.png'))
              this.$set(this.slideImg,3,require('../../../static/img/deptIntroduction/对比剂.png'))
            }


            for (let i = 1; i <= 4; i++) {
              let offsetTop = document.getElementById(('index'+i)).offsetTop;
              // 获取监听元素本身高度
              let scrollHeight = document.getElementById(('index'+i)).scrollHeight;
              // 如果 dom滚动位置 >= 元素距离视窗距离 && dom滚动位置 <= 元素距离视窗距离+元素本身高度
              // 则表示页面已经滚动到可视区了。
              if (scrollTop >= offsetTop && scrollTop<=(offsetTop+scrollHeight)) {
                //恢复原有状态
                this.$set(this.slideImg, 0, require('../../../static/img/deptIntroduction/影像.png'))
                this.$set(this.slideImg, 1, require('../../../static/img/deptIntroduction/超声.png'))
                this.$set(this.slideImg, 2, require('../../../static/img/deptIntroduction/生命关爱.png'))
                this.$set(this.slideImg, 3, require('../../../static/img/deptIntroduction/对比剂.png'))
                // 导航栏背景色选中
                this.$set(this.slideImg, (i - 1), this.selectedImg[i-1])

              }


              ////
              offsetTop = document.getElementById(('end'+i)).offsetTop;
              // 获取监听元素本身高度
              scrollHeight = document.getElementById(('end'+i)).scrollHeight;
              // 如果 dom滚动位置 >= 元素距离视窗距离 && dom滚动位置 <= 元素距离视窗距离+元素本身高度
              // 则表示页面已经滚动到可视区了。
              if (scrollTop >= offsetTop && scrollTop<=(offsetTop+scrollHeight)) {
                //恢复原有状态
                this.$set(this.slideImg, 0, require('../../../static/img/deptIntroduction/影像.png'))
                this.$set(this.slideImg, 1, require('../../../static/img/deptIntroduction/超声.png'))
                this.$set(this.slideImg, 2, require('../../../static/img/deptIntroduction/生命关爱.png'))
                this.$set(this.slideImg, 3, require('../../../static/img/deptIntroduction/对比剂.png'))
                // 导航栏背景色选中
                this.$set(this.slideImg, (i - 1), this.selectedImg[i-1])

              }
            }
          }

        }
      },
      mounted(){
        let point = this.$route.query.point;
        if (point!=undefined){
          this.slide(point);
        }
        window.addEventListener('scroll', () => {
          this.scrollToTop()
        },true);
      }
    }
</script>


<style scoped>
  .imgTite{
    padding-top: 32px;
  }
  .imgdiv{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .auxiliary{
    position: absolute;
    top: 0px;
    width: 1px;
    height: 40%;
  }
  .imgdiv img{
    width: 100%;
  }
  .DW{
    position: fixed;                 /* 绝对定位，不管滚动条上下滚动都在相应的位置*/
    width:80px;                       /*设置标签的宽*/
    /*height: 400px;                     !*设置标签的高*!*/
    /*background-color: aquamarine;    !*设标签背景色*!*/
    margin-top:-20%;                 /*减去的是标签高的一半*/
    margin-left: -10%;               /*减去的是标签宽的一半*/

    right: 10%;                       /*标签相对左边的一半 可以变成：right*/
    z-index: 3;
  }
  .DW [isActive]{
    background-color: red;
  }
  .navigate-absolute{
    position: absolute;
    z-index: 100;
  }
  .navigate-fixed{
    height: 0px;
    display: flex;
    flex-direction: column;
    padding: 0 11% 0 0;
    align-items: flex-end;
    position: sticky;
    top: 0;
    z-index: 100;
    right: 308px;
  }
  @media (min-width: 1480px) and (max-width: 1600px) {
    .navigate-fixed{
      padding-right: 8%;                       /*标签相对左边的一半 可以变成：right*/
    }
  }
  @media (min-width: 1182px) and (max-width: 1479px) {
    .navigate-fixed{
      padding-right: 7.5%;                       /*标签相对左边的一半 可以变成：right*/
    }
  }
  @media (min-width: 986px) and (max-width: 1180px) {
    .navigate-fixed{
      padding-right: 6.5%;                       /*标签相对左边的一半 可以变成：right*/
    }
  }
  @media (min-width: 800px) and (max-width: 986px) {
    .navigate-fixed{
      padding-right: 6%;                        /*标签相对左边的一半 可以变成：right*/
    }
  }
  .end80{
    height: 80px;
    width: 80px;
    padding-bottom: 10px;
    cursor:pointer;
  }

  .deptimage1{
    position: relative;
    width: 63%;
    background: #f4f4f4;
    margin: 35px auto 0 auto;
  }
  .subtitle{
    letter-spacing: 2px;
    margin: 0 auto;
    width: 180px;
    height: 39px;
    font-size: 40px;
    font-weight: 600;
    color: #666666;
    line-height: 52px;
  }
  .titleImg{
    text-align:center;
    margin-top: 38px;
  }
  .triangle{
    margin: 20px auto;
    width: 0px;
    height: 0px;
    border: 22px solid transparent;
    border-radius: 10px 10px 20px 20px;
    border-top-color: rgb(100,0,160);
  }
  /*第一部分*/
  .dept1{
    width: 313px;
    height: 313px;
    background: #c803a1;
    position: absolute;
    margin: auto;
    top: -20px;
    left: -20px;
    text-align: center;
    z-index: -1;
  }
  .dept2{
    width: 313px;
    height: 313px;
    background: #0770d8;
    position: absolute;
    margin: auto;
    bottom: -20px;
    right: -20px;
    text-align: center;
    z-index: -1;
  }


  .dept4{
    width: 40%;
    float: right;
    margin-left: 42px;
  }

  .dept4 img {
    width: 100%;
    margin-bottom: 15px;

  }
  .dept4p {
    padding: 40px 50px 50px 50px;
    font-size: 22px;
    font-weight: 400;
    color: #787878;
    line-height: 42px;
  }

  /*第二部分*/
  .two_img{
    position: relative;
    width: 40%;
    z-index: 1;
  }
  .two_img img{
    padding-left: 44px;
    width: 100%;
    margin-right: 50px;
    margin-bottom: 15px;
  }

  .two_imgp {
    padding: 40px 50px 50px 50px;
    font-size: 22px;
    font-weight: 400;
    color: #787878;
    line-height: 42px;

  }

  .us2{
    width: 26.3%;
    height: 313px;
    background: #640acd;
    position: absolute;
    margin: auto;
    top: -20px;
    left: 20px;
    text-align: center;
    z-index: 0;
  }

  .us1{
    width: 50px;
    height: 201px;
    background: #0770d8;
    position: absolute;
    margin: auto;
    bottom: 152px;
    right: -24px;
    text-align: center;
    z-index: -1;
  }
  .us3{
    width: 313px;
    height: 313px;
    background: #c803a1;
    position: absolute;
    margin: auto;
    bottom: -20px;
    right: -20px;
    text-align: center;
    z-index: -1;
  }

  /*第三部分*/
  .lifeCare{
    width: 26.3%;
    height: 313px;
    background: #c803a1;
    position: absolute;
    margin: auto;
    top: -20px;
    right: -20px;
    text-align: center;
    z-index: -1;
  }
  .lifeCare2{
    width: 188px;
    height: 30px;
    background: #640acd;
    position: absolute;
    top: -22px;
    left: 61px;
    z-index: -1;
  }
  .lifeCare3{
    width: 313px;
    height: 313px;
    background: #0770d8;
    position: absolute;
    bottom: -20px;
    left: -20px;
    z-index: -1;
  }
  /*第四部分*/
  .contrastAgent1{
    width: 26.3%;
    height: 313px;
    background: #640acd;
    position: absolute;
    top: -20px;
    left: 20px;
    z-index: 0;
  }
  .contrastAgent2{
    width: 91px;
    height: 66px;
    background: #c803a1;
    position: absolute;
    bottom: -23px;
    left: 32px;
    z-index: -1;
  }
  .contrastAgent3{
    width: 26.3%;
    height: 313px;
    background: #c803a1;
    position: absolute;
    bottom: -20px;
    right: -20px;
    z-index: -1;
  }
  .replenish{
    height: 388px;
  }

  @media (min-width: 801px) and (max-width: 1000px){
    .imgdiv img{
      width: 100%;
    }
  }
  /*@media (min-width: 1001px) and (max-width: 1200px){*/
  /*  .imgdiv img{*/
  /*    width: 100%;*/
  /*  }*/
  /*}*/
  /*@media (min-width: 1201px) and (max-width: 1400px){*/
  /*  .imgdiv img{*/
  /*    width: 100%;*/
  /*  }*/
  /*}*/
  /*@media (min-width: 1401px) and (max-width: 1600px){*/
  /*  .imgdiv img{*/
  /*    width: 100%;*/
  /*  }*/
  /*}*/
  /*@media (min-width: 1601px) and (max-width: 1800px){*/
  /*  .imgdiv img{*/
  /*    width: 100%;*/
  /*  }*/
  /*}*/

  @media screen and (max-width: 800px) {
    .imgdiv img{
      width: 100%;
    }
    .deptimage1{
      width: 70%;
    }
    .two_imgp{
      padding: 20px 20px 20px 20px;
      font-size: 11px;
      line-height: 20px;
    }
    .two_img img{
      padding-left: 0px;
      margin-right: 20px;
    }
    .two_img {
      padding-left: 20px;
      margin-right: 10px;
    }
    .dept4{
      padding-left: 10px;
    }

    .dept4p {
      padding: 20px 20px 20px 20px;
      font-size: 11px;
      line-height: 20px;
    }

    .dept4{
      margin-left: 8px;
    }

    /*第一部分*/
    .dept1{
      width: 130px;
      height: 130px;
      top: -8px;
      left: -8px;
    }
    .dept2{
      width: 130px;
      height: 130px;
      bottom: -8px;
      right: -8px;
    }

    .us2{
      width: 130px;
      height: 130px;
      top: -8px;
      left: 8px;
    }

    .us1{
      width: 20px;
      height: 83px;
      bottom: 63px;
      right: -9px;
    }
    .us3{
      width: 130px;
      height: 130px;
      bottom: -8px;
      right: -8px;
    }
    /*第三部分*/
    .lifeCare{
      width: 130px;
      height: 130px;
      top: -8px;
      right: -8px;
    }
    .lifeCare2{
      width: 78px;
      height: 12px;
      top: -9px;
      left: 25px;
    }
    .lifeCare3{
      width: 130px;
      height: 130px;
      bottom: -8px;
      left: -8px;
    }

    /*第四部分*/
    .contrastAgent1{
      width: 130px;
      height: 130px;
      top: -8px;
      left: 8px;
    }
    .contrastAgent2{
      width: 37px;
      height: 27px;
      bottom: -9px;
      left: 13px;
    }
    .contrastAgent3{
      width: 130px;
      height: 130px;
      bottom: -8px;
      right: -8px;
    }
    .titleImg{
      margin-top: 32px;
    }
    .titleImg img{
      width: 5.2%;
      height: 5.7%;
    }
    .subtitle{
      width: 74px;
      height: 16px;
      font-size: 16px;
      font-weight: 600;
      line-height: 21px;
    }
    .triangle{
      margin: 8px auto;
      width: 0px;
      height: 0px;
      border: 9px solid transparent;
      border-radius: 10px 10px 20px 20px;
      border-top-color: #640acd;
    }
    .navigate-fixed{
      padding-right: 1%;
    }

    .end80{
      width: 30px;
      height: 30px;
    }
    .replenish{
      height: 153px;
    }

  }

  @media (min-width: 801px) and (max-width: 1200px){
    .deptimage1{
      width: 70%;
    }
    .two_imgp{
      padding: 27px 27px 27px 27px;
      font-size: 13.5px;
      line-height: 25px;
    }
    .two_img img{
      padding-left: 24px;
      margin-right: 27px;
    }
    .dept4{
      margin-left: 27px;
    }

    .dept4p {
      padding: 27px 27px 27px 27px;
      font-size: 13.5px;
      line-height: 25px;
    }

    .dept4{
      margin-left: 27px;
    }

    /*第一部分*/
    .dept1{
      width: 163px;
      height: 163px;
      top: -10px;
      left: -10px;
    }
    .dept2{
      width: 163px;
      height: 163px;
      bottom: -10px;
      right: -10px;
    }

    .us2{
      width: 163px;
      height: 163px;
      top: -10px;
      left: 10px;
    }

    .us1{
      width: 25px;
      height: 104px;
      bottom: 79px;
      right: -12px;
    }
    .us3{
      width: 163px;
      height: 163px;
      bottom: -10px;
      right: -10px;
    }
    /*第三部分*/
    .lifeCare{
      width: 163px;
      height: 163px;
      top: -10px;
      right: -10px;
    }
    .lifeCare2{
      width: 97px;
      height: 15px;
      top: -12px;
      left: 32px;
    }
    .lifeCare3{
      width: 163px;
      height: 163px;
      bottom: -10px;
      left: -10px;
    }

    /*第四部分*/
    .contrastAgent1{
      width: 163px;
      height: 163px;
      top: -10px;
      left: 10px;
    }
    .contrastAgent2{
      width: 47px;
      height: 34px;
      bottom: -12px;
      left: 17px;
    }
    .contrastAgent3{
      width: 163px;
      height: 163px;
      bottom: -10px;
      right: -10px;
    }
    .titleImg{
      margin-top: 49px;
    }
    .titleImg img{
      width: 5.2%;
      height: 5.7%;
    }
    .subtitle{
      width: 93px;
      height: 20px;
      font-size: 20px;
      font-weight: 600;
      line-height: 27px;
    }
    .triangle{
      margin: 10px auto;
      width: 0px;
      height: 0px;
      border: 11px solid transparent;
      border-radius: 10px 10px 20px 20px;
      border-top-color: #640acd;
    }

    .replenish{
      height: 192px;
    }
    .DW{
      width:60px;                       /*设置标签的宽*/
      right: 40px;                       /*标签相对左边的一半 可以变成：right*/
    }
    .end80{
      width: 50px;
      height: 50px;
    }
  }

  @media (min-width: 1201px) and (max-width: 1550px){
    .deptimage1{
      width: 70%;
    }

    .two_imgp{
      padding: 33px 33px 33px 33px;
      font-size: 25px;
      line-height: 40px;
    }
    .two_img img{
      padding-left: 32px;
      margin-right: 33px;
    }


    .dept4p {
      padding: 33px 33px 33px 33px;
      font-size: 25px;
      line-height: 40px;
    }

    .dept4{
      margin-left: 30px;
    }

    /*第一部分*/
    .dept1{
      width: 203px;
      height: 203px;
      top: -12px;
      left: -12px;
    }
    .dept2{
      width: 203px;
      height: 203px;
      bottom: -12px;
      right: -12px;
    }

    .us2{
      width: 203px;
      height: 203px;
      top: -12px;
    }

    .us1{
      width: 31px;
      height: 130px;
      bottom: 99px;
      right: -11px;
    }
    .us3{
      width: 203px;
      height: 203px;
      bottom: -12px;
      right: -12px;
    }
    /*第三部分*/
    .lifeCare{
      width: 203px;
      height: 203px;
      top: -12px;
      right: -12px;
    }
    .lifeCare2{
      width: 97px;
      height: 15px;
      top: -12px;
      left: 32px;
    }
    .lifeCare3{
      width: 203px;
      height: 203px;
      bottom: -12px;
      left: -12px;
    }

    /*第四部分*/
    .contrastAgent1{
      width: 203px;
      height: 203px;
      top: -12px;
    }
    .contrastAgent2{
      width: 59px;
      height: 42px;
      bottom: -15px;
      left: 21px;
    }
    .contrastAgent3{
      width: 203px;
      height: 203px;
      bottom: -12px;
      right: -12px;
    }
    .titleImg{
      margin-top: 70px;
    }
    .titleImg img{
      width: 5.2%;
      height: 5.7%;
    }
    .subtitle{
      width: 117px;
      height: 25px;
      font-size: 25px;
      font-weight: 600;
      line-height: 34px;
    }
    .triangle{
      margin: 13px auto;
      width: 0px;
      height: 0px;
      border: 13px solid transparent;
      border-radius: 10px 10px 20px 20px;
      border-top-color: #640acd;
    }
    .replenish{
      height: 238px;
    }
    .DW{
      width:70px;                       /*设置标签的宽*/
      right: 70px;                       /*标签相对左边的一半 可以变成：right*/
    }
    .end80{
      width: 70px;
      height: 70px;
    }
  }
  @media (min-width: 1920px) and (max-width: 2305px){
    .auxiliary{
      height: 30%;
    }
  }
  @media (min-width: 2306px) and (max-width: 3100px){
    .auxiliary{
      height: 20%;
    }
  }

  @media screen and (max-width: 500px) {
    .navigate-fixed{
      top: 15px;
    }
  }

</style>




// WEBPACK FOOTER //
// src/views/web/deptIntroduction.vue